export default __webpack_public_path__ + "static/media/the-heart-wants-what-it-wants.d6c4f2d6.mp3";